/**
 * @file   src\components\SidebarMenu.tsx
 * @brief  Sidebar Menu component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { useState, useEffect, useNavigate, Offcanvas, Modal, Button, useRef, useLocation, React } from '../utils/thirdpartyComponents';
import Supporticon from '../assets/images/customer-support.svg';
import MainMenu from './MainMenu';
import "../components/Offcanvas.scss";
import { pageURLs } from '../utils/pageUrls';
import axios from '../config/axiosConfig';
import { AuthApi } from '../utils/apiUrls';
import { MessageToaster } from '../utils/toastUtil';
import { resetAuthState } from '../store/slices/authSlice';
import { useAppDispatch } from '../hooks';
import Cookies from 'js-cookie';
import { getFromLocalStorage } from '../utils/helper';

const SidebarMenu = (props: any) => {
  // Declare action dispatch.
  const dispatch = useAppDispatch();
  const storageData = getFromLocalStorage('CARWASH_ADMIN_DATA');
  const userInfo = storageData && storageData !== null ? storageData : null;
  const { show, onHide } = props;
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState<boolean>(false)
  const [activeLink, setActiveLink] = useState<string>(''); // Track the active link

  // Instantiate MessageToaster
  const toaster = new MessageToaster();
  const navigate = useNavigate();
  const location = useLocation();

  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {

    //To hide sidebar menu if clicked outside
    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show]);



  const handleClickOutside = (event: MouseEvent) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
      // Hide the sidebar when clicking outside
      onHide();
    }
  };

  // To show popup
  const signout = () => {
    setShowLogoutConfirmation(true)
  }

  //Hide ppopup
  const handleOnHide = () => {
    setShowLogoutConfirmation(false)
  }


  // Redirect to login page on confirm
  const ConfirmLogout = async () => {

    // API call to sign up
    try {
      const { data } = await axios.post(AuthApi.LOGOUT);
      dispatch(resetAuthState());
      localStorage.clear();
      Cookies.remove('accessToken');
      Cookies.remove('refreshToken');
      if (data?.error == 0) {
        window.location.href = `/superadmin/${pageURLs.root}`
        // navigate(`/superadmin/${pageURLs.root}`)
        setShowLogoutConfirmation(false);
      }
      else {
        // show error message
        toaster.toastError(data?.message);
      }
    } catch (error: any) {
      throw new Error(error?.response?.data?.message || error?.message);
    }
  }


  useEffect(() => {
    const lastUrlSegment = location.pathname.split('/').pop(); // Get the last URL segment
    setActiveLink(lastUrlSegment || ''); // Set the last segment as active link
  }, [location.pathname]); // Run whenever the URL changes

  //Redirect to menu pages
  const onMenuClick = (url: string, active_link: string) => {
    navigate(url)
    setActiveLink(active_link)
    onHide()
  }

  return (
    <Offcanvas show={show} onHide={onHide} placement="end" className="menu-offcanvas">
      <Offcanvas.Header closeButton>
      </Offcanvas.Header>
      <Offcanvas.Body ref={sidebarRef} className='scroll-custom'>
        <MainMenu />
        <a href={void 0} onClick={() => onMenuClick(`/superadmin/${pageURLs.my_profile}`, 'my-profile')} className={`f-medium ${activeLink === 'my-profile' ? 'active' : ''}`}>My Profile</a>
        {!(userInfo?.userTypeId == 2 && userInfo?.permissionType == 2)
          && <a href={void 0} onClick={() => onMenuClick(`/superadmin/${pageURLs.admin_users}`, 'admin-users')} className={`f-medium ${activeLink === 'admin-users' ? 'active' : ''}`}>Admin Users</a>}
        <a href={void 0} onClick={() => signout()} className='f-medium'>Sign Out</a>
      </Offcanvas.Body>
      {!(userInfo?.userTypeId == 2 && userInfo?.permissionType == 2)
        && <div className='menu-footer' onClick={() => navigate(`/superadmin/${pageURLs.customer_support_desk}`)}>
          <div className="customer-support-desk d-flex align-items-center" onClick={() => navigate(`/superadmin/${pageURLs.customer_support_desk}`)} >
            <h5>Customer <span className='f-bold'>Support</span> Desk</h5>
            <img src={Supporticon} alt="Car Wash App" />
          </div>
        </div>}
      {/* signout confirmation Modal */}
      <Modal
        show={showLogoutConfirmation}
        onHide={handleOnHide}
        centered
        className='add-modal'
      >
        <Modal.Body className='text-center'>
          <h5 className='f-bold text-center'>Are you sure you want to Sign Out?</h5>
          <div className="btn-sec d-grid">
            <Button variant="light" className="secondary-btn" onClick={handleOnHide}>Cancel</Button>
            <Button variant="primary" className='primary-btn btn-main m-0' onClick={ConfirmLogout}>Yes</Button>
          </div>
        </Modal.Body>
      </Modal>
    </Offcanvas>

  );
};
export default SidebarMenu;
